import { useState, useEffect } from "react";

import SettingsObjectDetailsSlider from "../../SettingsObjectDetailsSlider";
import ContactsTab from "../vendors/ContactsTab";
import YearlyReportsSection from "./YearlyReportsSection";
import ProductsSection from "./ProductsSection";
import PaidDataSharingTab from "./PaidDataSharingTab";

import { useAccountData } from "../../../../../helpers/firebase";
import { fetchOurApi } from "../../../../../helpers/utils/apiCalls";

const EMPTY_MAP = {};

const CustomerDetailsSlider = ({ selectedCustomer, setSelectedCustomer }) => {
  const [{ id: accountId }] = useAccountData();

  const {
    id: relationshipId,
    buyerName,
    buyerId,
    vendorId,
    customerContacts = [],
    hasExplorerAccount,
    surveyData = [],
    sharedProducts = []
  } = selectedCustomer;

  const [buyerProducts, setBuyerProducts] = useState([]);

  useEffect(() => {
    if (!accountId || !buyerId) {
      return;
    }
    fetchOurApi({
      path: "/vendors/fetch-buyer-product-bom-requests",
      method: "POST",
      data: { vendorId: accountId, buyerId }
    }).then((results) => setBuyerProducts(results || []));
  }, [accountId, buyerId]);

  const views = [
    {
      label: "Contacts",
      value: "contacts",
      content: (
        <ContactsTab
          vendorId={vendorId || accountId}
          relationshipId={relationshipId}
          vendorContacts={customerContacts}
          hasExplorerAccount={hasExplorerAccount}
          isCheckingSubscription={false}
          individualsMap={EMPTY_MAP}
          contactsField="customerContacts"
          inviteApiPath="/vendors/invite-customer-to-explorer"
          getExtraInviteData={() => ({ vendorId: accountId })}
        />
      )
    },
    {
      label: "Yearly Reports",
      value: "yearly-reports",
      content: (
        <YearlyReportsSection customer={selectedCustomer} isReadOnly={false} />
      )
    },
    {
      label: "Products",
      value: "products",
      content: (
        <ProductsSection
          customer={selectedCustomer}
          isReadOnly={false}
          buyerAssignedProducts={buyerProducts}
        />
      )
    },
    {
      label: "Data Sharing",
      value: "data-sharing",
      content: (
        <PaidDataSharingTab
          relationshipId={relationshipId}
          surveyData={surveyData}
          linkedProducts={sharedProducts}
          buyerBomRequests={buyerProducts}
          onBuyerBomRequestUpdated={(lifecycleId, newBomStatus) =>
            setBuyerProducts((prev) =>
              prev.map((p) =>
                p.lifecycleId === lifecycleId
                  ? { ...p, bomStatus: newBomStatus }
                  : p
              )
            )
          }
        />
      )
    }
  ];

  return (
    <SettingsObjectDetailsSlider
      type="customers"
      settingsObject={{ ...selectedCustomer, name: buyerName }}
      views={views}
      setSelectedObject={setSelectedCustomer}
      noFooter
      editNameDisabled
    />
  );
};

export default CustomerDetailsSlider;
